module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/bikes/bikes-list/bikes-list.component.css
// module id = ./src/app/bikes/bikes-list/bikes-list.component.css
// module chunks = main